
import './App.css';
import AppRoutes from './routes/AppRoutes';
import { BrowserRouter } from "react-router-dom";
import { initMeetAddon } from './addon/meetInit';
import { useDispatch } from "react-redux";

function App() {
  const dispatch = useDispatch();
  initMeetAddon(dispatch);
  return (
   <BrowserRouter>
     
   <AppRoutes/>
   </BrowserRouter>
  
  );
}

export default App;
